<script setup>
import {computed, watch, getCurrentInstance} from 'vue'
import FormControlTypeRelationshipOneToMany from '../../common/form-control-type/FormControlTypeRelationshipOneToMany'

const props = defineProps({
    formId: String,
    field: Object,
    currentData: Object,
    value: Number
})

const {proxy} = getCurrentInstance()
const store = proxy.$store

// --- Computed ---
const itemId = computed(() => props.currentData.id || 0)

// --- Watcher ---
watch(() => props.value, (newCourseDateId) => {
    if (
        !itemId.value &&
        newCourseDateId
    ) {
        store.dispatch('itemData/get', {
                tableName: 'odp_course_dates',
                id: newCourseDateId
            })
            .then((obj) => {
                store.commit(props.formId + '/set', {
                    name: 'agreedPrice',
                    value: obj.price,
                })
            })
    }
})
</script>

<template>
    <FormControlTypeRelationshipOneToMany
        :current-data="currentData"
        :field="field"
        :form-id="formId"
    />
</template>